import { ELanguage } from '../interfaces/language.interface';

export function getLocalizedDescription(descriptions: { [key in ELanguage]?: string } | undefined, currentLang: ELanguage): string {
  if (!descriptions) {
    return '';
  }

  return (
    [descriptions[currentLang], descriptions[ELanguage.EN], ...Object.values(descriptions)].find((value) => !!value?.trim()) ?? ''
  );
}
